const tireInspectionPage = () => import('@/pages/pickUpTyre/tireInspectionPage')
const tireBindingDetailCopy = () => import('@/pages/pickUpTyre/tireBindingDetail')
const tireBindingPageCopy = () => import('@/pages/pickUpTyre/tireBindingPage')
const unbindReplacePageCopy = () => import('@/pages/pickUpTyre/unbindReplacePage')
export default [
  {
    path: '/tireInspectionPage',
    name: 'tireInspectionPage',
    component: tireInspectionPage,
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/tireBindingDetailCopy',
    name: 'tireBindingDetailCopy',
    component: tireBindingDetailCopy,
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/tireBindingPageCopy',
    name: 'tireBindingPageCopy',
    component: tireBindingPageCopy,
    meta: {
      storeKey: '*'
    }
  },
  {
    path: '/unbindReplacePageCopy',
    name: 'unbindReplacePageCopy',
    component: unbindReplacePageCopy,
    meta: {
      storeKey: '*'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/pickUpTyre/index.js